import { NEXUS_ADMIN_ROLE_NAME } from './platform-admin-permissions.js';
import { SmartTeamsRoleNames } from './smartteams-permissions.js';

/** Roles shown on Nexus “Role management” matrix (NSC platform admin + Nexus-*). */
export function isNexusRoleManagementRoleName(roleName: string | undefined): boolean {
  const n = roleName ?? '';
  if (n === NEXUS_ADMIN_ROLE_NAME) return true;
  return n.startsWith('Nexus ');
}

const SMART_TEAMS_ROLE_MATRIX_NAMES = new Set<string>([
  SmartTeamsRoleNames.NSC_ADMIN,
  SmartTeamsRoleNames.PARTNER_MANAGER,
  SmartTeamsRoleNames.NSC_AGENT,
]);

/** Roles shown on SmartTeams “Role management” matrix (NSC platform admin + SmartTeams operational roles). */
export function isSmartTeamsRoleManagementRoleName(roleName: string | undefined): boolean {
  return SMART_TEAMS_ROLE_MATRIX_NAMES.has(roleName ?? '');
}
